/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon20Light = forwardRef('TechPowerButtonIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 1.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z" }),
        React.createElement("path", { d: "M5.716 4.215a.5.5 0 1 0-.582-.813 7.5 7.5 0 1 0 8.74.006.5.5 0 1 0-.583.812 6.5 6.5 0 1 1-7.575-.005Z" })));
});
